let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("2LeFl")]).then(() => parcelRequire('2W0DL'));